"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _icon = _interopRequireDefault(require("./icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchIcon = function SearchIcon(props) {
  var id = props.id,
      className = props.className;
  return _react.default.createElement(_icon.default, {
    id: id ? id : null,
    className: className
  }, _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, _react.default.createElement("title", {
    id: id ? "".concat(id, "_title") : null
  }, "Search"), _react.default.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, _react.default.createElement("g", {
    id: "info"
  }, _react.default.createElement("path", {
    d: "M15.61,13.72l-3.48-3.48-.06,0a6.58,6.58,0,1,0-1.88,1.88l0,.06,3.48,3.48a1.34,1.34,0,0,0,1.89-1.89Zm-9-2.84a4.3,4.3,0,1,1,4.3-4.3A4.3,4.3,0,0,1,6.58,10.88Z"
  })))));
};

var _default = SearchIcon;
exports.default = _default;